const theme = {
  primaryColor: 'rgb(228, 227, 227)',
  secondaryColor: 'rgb(173,216,230)',
  fontColor: 'rgb(97, 97, 97)'
};

export default theme;
